module.exports = __webpack_public_path__ + "img/newhead.0633f664.png";